import { render } from "./BrandMain.vue?vue&type=template&id=a614d468&scoped=true"
import script from "./BrandMain.vue?vue&type=script&lang=js"
export * from "./BrandMain.vue?vue&type=script&lang=js"

import "./BrandMain.vue?vue&type=style&index=0&id=a614d468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a614d468"]])

export default __exports__